export const siteSlice = (set,get) =>({
    clinicId:1,
    user:{},
    userInfo:null,
    clinicInfo:null,
    selectedUser:{},
    todaysAppointment:[],
    sidebarCollapsed:false,
    sidebarToggled: false,
    sidebarBroken : false,
    smsInbox:0,
    notifications:0,
    smsSidebarCollapsed:false,
    setTodaysAppointment: (appointment) => set((state)=>({todaysAppointment:appointment})),
    setSidebarCollapsed: (collapsed) =>set((state)=>({sidebarCollapsed:collapsed})),
    toggleSidebarCollapsed:()=>set(state=>({sitebarCollapsed: !state.sitebarCollapsed})),
    toggleSidebar: () =>set((state)=>({sidebarToggled:!state.sidebarToggled})),
    setSidebarBroken : (broken) =>set((state)=>({sidebarBroken:broken})),
    setClinicId :(newclinicId) => set((state)=>({clinicId:newclinicId})),
    setUser : (newUser) => set((state)=>({user : newUser})),
    setUserInfo : (newUserInfo) => set((state)=>({userInfo : newUserInfo})),
    setClinicInfo : (newClinicInfo) => set((state)=>({clinicInfo : newClinicInfo})),
    setSmsInbox : (newSmsInbox) =>set((state)=>({smsInbox:newSmsInbox})),
    incrementSmsInbox: () => set((state) => ({ smsInbox: state.smsInbox + 1 })),
    incrementNotifications: () => set((state) => ({ notifications: state.notifications + 1 })),
    resetNotifications: () => set({ notifications: 0 }),
    setSmsSidebarCollapsed: (collapsed) => set({ smsSidebarCollapsed: collapsed }),
    toggleSmsSidebarCollapsed: () => set((state) => ({ smsSidebarCollapsed: !state.smsSidebarCollapsed })),
    setSelectedUser:(newSelectedUser) => set((state)=>({selectedUser : newSelectedUser})),
    // --- Patient Page Search State ---
    patientSearch: {
        patients: [],
        searchTerm: '',
        searchColumn: '',
        pagination: null,
        pageNo: 0,
        searchPerformed: false,
    },

    setPatientSearch: (data) =>
        set((state) => ({
            patientSearch: { ...state.patientSearch, ...data }
        })),

    clearPatientSearch: () =>
        set((state) => ({
            patientSearch: {
                patients: [],
                searchTerm: '',
                searchColumn: '',
                pagination: null,
                pageNo: 0,
                searchPerformed: false,
            }
        })),
})